"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MultiSelectFormatter;

var _Box2 = _interopRequireDefault(require("@material-ui/core/Box"));

var _Chip2 = _interopRequireDefault(require("@material-ui/core/Chip"));

var _Button2 = _interopRequireDefault(require("@material-ui/core/Button"));

var _AddRounded2 = _interopRequireDefault(require("@material-ui/icons/AddRounded"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("../propTypes");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

MultiSelectFormatter.propTypes = _propTypes.EditorProps;

function MultiSelectFormatter(_ref) {
  var row = _ref.row,
      column = _ref.column,
      onRowChange = _ref.onRowChange,
      isCellSelected = _ref.isCellSelected,
      rowIdx = _ref.rowIdx;
  var isEditable = column === null || column === void 0 ? void 0 : column.isEditable;

  var handleClick = function handleClick(event) {
    var resolvedAnchorEl = event.currentTarget.getBoundingClientRect();

    var anchorEl = function anchorEl() {
      return {
        nodeType: 1,
        getBoundingClientRect: function getBoundingClientRect() {
          return resolvedAnchorEl;
        }
      };
    };

    column.setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        column: column,
        row: row,
        rowIdx: rowIdx,
        openMultiSelectMenu: anchorEl
      });
    });
  };

  var handleClose = function handleClose() {
    column.setState(function (state) {
      return _objectSpread(_objectSpread({}, state), {}, {
        column: null,
        row: null,
        rowIdx: null,
        openMultiSelectMenu: null
      });
    });
  };

  var value = (row === null || row === void 0 ? void 0 : row[column === null || column === void 0 ? void 0 : column.key]) || [];

  var handleDelete = function handleDelete(item, index) {
    var newValue = value.map(function (item) {
      return item.id;
    });
    newValue.splice(index, 1);
    onRowChange(_objectSpread(_objectSpread({}, row), {}, _defineProperty({}, column.key, newValue)));
    handleClose();
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Box2["default"], {
    display: "flex",
    alignItems: "center",
    flexWrap: "no-wrap",
    onClick: value.length === 0 && isEditable ? handleClick : null,
    style: {
      height: "100%",
      position: "relative",
      width: "100%"
    }
  }, isCellSelected && isEditable ? /*#__PURE__*/_react["default"].createElement(_Button2["default"], {
    variant: "contained",
    style: {
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
      borderRadius: "0.25rem",
      zIndex: 1,
      padding: 0,
      marginRight: 2,
      marginLeft: -2,
      minWidth: 16,
      height: 16
    },
    onClick: handleClick
  }, /*#__PURE__*/_react["default"].createElement(_AddRounded2["default"], {
    style: {
      fontSize: 14
    }
  })) : null, Array.isArray(value) && value.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(_Chip2["default"], {
      size: "small",
      label: item === null || item === void 0 ? void 0 : item.value,
      color: "primary",
      onDelete: isCellSelected && isEditable ? function () {
        return handleDelete(item, index);
      } : null,
      key: index,
      style: {
        marginRight: 2,
        backgroundColor: item === null || item === void 0 ? void 0 : item.color,
        color: "white"
      }
    });
  })));
}